import { defineStore } from 'pinia'

export const useServiceStore = defineStore('service', {
  state: () => {
    return {
      services: [
        {
            id: 1,
            title: 'Kinesitherapie',
            short_description: 'Kinesitherapie helpt je bewegen zonder pijn door oefentherapie, manuele technieken en dry needling. Op basis van een gericht onderzoek stellen we een behandelplan op maat op voor een optimaal herstel.',
            image: require('../assets/images/kinesitherapie/1.jpg'),
            additionalStyling: 'object-top'
        },
        {
            id: 2,
            title: 'Hartcoherentie',
            short_description: 'Met een specifieke ademhalingstechniek brengen we je hart in rustmodus. Dit zorgt voor meer balans in je brein, waardoor je stressbestendigheid en veerkracht toenemen.<br />',
            image: require('../assets/images/hartcoherentie/1.jpg'),
        },
        {
            id: 3,
            title: 'Bikefitting',
            short_description: 'Fietsen hoort niet pijnlijk te zijn. Met een lichaamsscreening en het Retül-systeem optimaliseren we jouw positie voor meer comfort en efficiëntie. Zo voorkomen we blessures en haal je het beste uit elke rit!',
            image: require('../assets/images/bikefitting/1.png'),
        },
        {
            id: 4,
            title: 'Training',
            short_description: "Samen werken aan jouw doelen! Met een doordacht trainings- en voedingsplan verbeteren we jouw kracht, uithouding en mobiliteit. Zo bouwen we stap voor stap aan een fittere versie van jezelf!",
            image: require('../assets/images/training/1.jpg'),
            additionalStyling: 'object-top'
        }
      ],

      kine: [
        {
          id: 1,
          title: 'Algemene kinesitherapie',
          description: 'Algemene kinesitherapie richt zich op het verhelpen van lichamelijke klachten door een actieve aanpak. Met gerichte oefeningen, manuele technieken en praktische adviezen helpen we je om pijn te verlichten, je mobiliteit te verbeteren en sneller te herstellen. We stellen een persoonlijk plan op, zodat je weer voluit kunt bewegen in je dagelijks leven.',
          image: require('../assets/images/kinesitherapie/k1.jpg')
        },
        {
          id: 2,
          title: 'Sportkinesitherapie',
          description: 'Sportkinesitherapie richt zich op het herstel van blessures en het optimaliseren van prestaties voor sporters. Door middel van specifieke testen, zoals kracht-, mobiliteit- en stabiliteitsmetingen, maken we een individueel oefenschema op maat. Met deze actieve aanpak helpen we je pijn te verlichten, je kracht en flexibiliteit te verbeteren en blessures te voorkomen, zodat jij zo snel mogelijk weer pijnvrij kunt genieten van jouw sport.',
          image: require('../assets/images/kinesitherapie/k2.jpg')        
        },
        {
          id: 3,
          title: 'Dry Needling',
          description: 'Dry Needling is een behandelmethode waarbij fijne naalden in specifieke spierpunten (triggerpoints) worden ingebracht om pijn te verlichten en spierspanning te verminderen. Door de naaldprikkeling wordt de doorbloeding verbeterd en kunnen spieren sneller herstellen. Dry needling is een effectieve aanvulling op andere therapieën, waarbij het pijnmanagement en herstel bevordert.',
          image: require('../assets/images/kinesitherapie/k3.jpg')
        },
        {
          id: 4,
          title: 'Rugscholing',
          description: "We richten ons op het behandelen en begeleiden van mensen met chronische lage rug klachten d.m.v. manuele technieken, aangepaste oefentherapie en het aanleren van een dynamisch en correct ruggebruik. (o.a. tips voor de werksituatie, sport, hobby's, ...)",
          image: require('../assets/images/kinesitherapie/k4.jpg')        
        },
        {
          id: 5,
          title: 'Post-operatieve revalidatie',
          description: 'Post operatieve revalidatie richt zich op het herstel na een operatie. Het doel is om het functionele niveau van het lichaam snel en effectief te herstellen, pijn te verminderen en de mobiliteit te verbeteren. We werken met een persoonlijk plan dat is afgestemd op jouw specifieke operatie en behoeften, waarbij we stap voor stap de kracht, flexibiliteit en stabiliteit terug opbouwen.',
          image: require('../assets/images/kinesitherapie/k5.jpg')
        },
        {
          id: 6,
          title: 'Manuele therapie',
          description: 'Manuele therapie is een behandelmethode die zich richt op het verhelpen van pijn en bewegingsbeperkingen in gewrichten, spieren en bindweefsel. Door middel van gerichte handmatige technieken, zoals mobilisaties en manipulaties, wordt de beweeglijkheid van gewrichten hersteld en worden spierspanning en blokkades verminderd. Manuele therapie helpt niet alleen bij acute pijnklachten, maar ook bij chronische problemen, en bevordert het herstel van een natuurlijke en pijnvrije beweging',
          image: require('../assets/images/kinesitherapie/k6.jpg')
        },
        {
          id: 7,
          title: 'Craniale therapie',
          description: "Craniale therapie is een manuele therapie via de schedel, het bekken en de diafragma's. Hierbij behandelen wij vooral klachten zoals burn-out, vermoeidheid, hoofdpijn, slecht slapen, verschillende vormen van stress, ...",
          image: require('../assets/images/kinesitherapie/k7.jpg')
        }
      ]
    }
  },
  actions: {
    getServices() {
        return this.services;
    },

    getService(id) {
        return this.services.find(service => service.id+"" === id+"");
    },

    getFourRandom(excludeId) {
        let service = this.services.filter(serv => serv.id+"" !== excludeId+"");
        return service.sort(() => Math.random() - Math.random()).slice(0, 4);
    }
  }
});
